// extracted by mini-css-extract-plugin
export default {"smBreak":"600px","hotelResult":"UJ7ap1I0tD4tQAPA_XJB"};